import React from 'react'
import product_banner from '../../assets/images/desktopImage_4_banner.jpg'
import product_banner_mobile from '../../assets/images/mobileImage_4.jpg'
import CommonBanner from "../../common/CommonBanner/CommonBanner";
import SEO from "../../common/SEO/SEO";
import Collection from '../../Components/Home/Collection/Collection';

const AllCollectionPage = () => {
  return (
    <div>
      <SEO
        title="Curated Collections & Seasonal Drops"
        description="Explore seasonal drops and curated wardrobe capsules from Maya Wears. Modern silhouettes crafted with restraint in Kathmandu, Nepal."
        canonical="https://mayawears.com.np/all_collection"
        keywords="Maya Wears collections, seasonal drops Nepal, contemporary fashion capsules, clothing collections Kathmandu"
      />
      <CommonBanner  product_banner={product_banner} product_banner_mobile={product_banner_mobile} title="Curated Collections Archive" subtitle="A Study in Form, Movement and Modern Craft"  />
      <Collection isAll={true} />
    </div>
  )
}

export default AllCollectionPage